exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-hidden[data-v-2d8734be] {\n  display: none;\n}\n.disable[data-v-2d8734be] {\n  color: white !important;\n  background-color: #CCCCCC !important;\n  cursor: inherit;\n}\n.trial-limit[data-v-2d8734be] {\n  text-align: center;\n  font-size: 14px;\n}\n.trialBox[data-v-2d8734be] {\n  height: 60px;\n}\n.personalBox[data-v-2d8734be] {\n  border: 1px solid #0042bd;\n}\n.corpolateBox[data-v-2d8734be] {\n  border: 1px solid #30876e;\n}\n.corpolateTitle[data-v-2d8734be] {\n  color: #30876e;\n}", ""]);

// exports
